/**
 * advise.js — modal "Nhận tư vấn" cho chai giá cao và quà biếu (partials/advise-modal.html).
 *
 * Nút mở: [data-advise] — data-advise-topic (product | gift | bulk) chọn sẵn nhu cầu,
 * data-advise-product điền sẵn tên chai vào ghi chú để sommelier biết khách hỏi chai nào.
 * Mở bằng window.WBModal (js/modal.js) nên khoá cuộn, giữ focus, Esc đóng… dùng chung
 * với mọi modal khác, không phải viết lại.
 *
 * Gửi form: kiểm tra họ tên + số điện thoại Việt Nam, rồi đổi sang khung "Đã nhận yêu cầu".
 * Đo lường: gift_lead_submit (chủ đề quà biếu) hoặc advise_lead_submit qua window.WBTrack.
 * WP: form POST tới admin-post.php (nonce + honeypot) và lưu lead — xoá phần giả lập gửi,
 * giữ phần mở modal / điền sẵn / kiểm tra.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var modal = document.getElementById('advise-modal');
    if (!modal) return;

    var form = modal.querySelector('[data-advise-form]');
    var formView = modal.querySelector('[data-advise-form-view]');
    var doneView = modal.querySelector('[data-advise-done]');
    var topicSelect = modal.querySelector('[data-advise-topic-select]');
    var note = modal.querySelector('[data-advise-note]');
    var PHONE = /^(0|\+84)(3|5|7|8|9)\d{8}$/;

    function reset() {
        if (!form) return;
        form.reset();
        formView.hidden = false;
        doneView.hidden = true;
        [].slice.call(form.querySelectorAll('.field')).forEach(function (field) {
            setError(field, '');
        });
    }

    function setError(field, message) {
        var error = field.querySelector('.field__error');
        var input = field.querySelector('input, select, textarea');
        field.classList.toggle('field--error', !!message);
        if (error) {
            error.textContent = message;
            error.hidden = !message;
        }
        if (input) {
            if (message) {
                input.setAttribute('aria-invalid', 'true');
                if (error) input.setAttribute('aria-describedby', error.id);
            } else {
                input.removeAttribute('aria-invalid');
            }
        }
    }

    document.addEventListener('click', function (event) {
        var trigger = event.target.closest ? event.target.closest('[data-advise]') : null;
        if (!trigger || !window.WBModal) return;
        event.preventDefault();

        reset();
        var topic = trigger.getAttribute('data-advise-topic') || 'product';
        var product = trigger.getAttribute('data-advise-product');
        if (topicSelect) topicSelect.value = topic;
        if (note && product) note.value = 'Tôi quan tâm: ' + product;
        modal.setAttribute('data-topic', topic);

        window.WBModal.open(modal);
        // modal.js đưa focus vào panel; chuyển tiếp vào ô đầu để gõ ngay
        var first = form && form.querySelector('input:not([type="hidden"])');
        if (first) window.setTimeout(function () { first.focus(); }, 60);
    });

    if (!form) return;

    form.addEventListener('submit', function (event) {
        event.preventDefault();
        // Tra ô bằng selector: form.name là thuộc tính "name" của chính thẻ <form>,
        // không phải ô nhập tên.
        var nameInput = form.querySelector('[name="name"]');
        var phoneInput = form.querySelector('[name="phone"]');
        var honeypot = form.querySelector('[name="website"]');

        // Bot điền ô ẩn → âm thầm bỏ qua
        if (honeypot && honeypot.value) return;

        var nameField = nameInput.closest('.field');
        var phoneField = phoneInput.closest('.field');
        var name = nameInput.value.trim();
        var phone = phoneInput.value.replace(/[\s.-]/g, '');
        var ok = true;

        setError(nameField, name ? '' : 'Vui lòng nhập họ và tên.');
        if (!name) ok = false;

        if (!phone) {
            setError(phoneField, 'Vui lòng nhập số điện thoại.');
            ok = false;
        } else if (!PHONE.test(phone)) {
            setError(phoneField, 'Số điện thoại chưa đúng định dạng (vd 0901 234 567).');
            ok = false;
        } else {
            setError(phoneField, '');
        }

        if (!ok) {
            var firstError = form.querySelector('[aria-invalid="true"]');
            if (firstError) firstError.focus();
            return;
        }

        var topic = topicSelect ? topicSelect.value : 'product';
        if (window.WBTrack) {
            window.WBTrack(topic === 'gift' ? 'gift_lead_submit' : 'advise_lead_submit', { topic: topic });
        }

        formView.hidden = true;
        doneView.hidden = false;
        var doneText = doneView.querySelector('[data-advise-done-text]');
        if (doneText) {
            doneText.textContent = 'Cảm ơn ' + name + '! Sommelier WINEBOSS sẽ gọi lại số ' +
                phoneInput.value.trim() + ' trong 15 phút (8:00 – 22:00).';
        }
        var close = doneView.querySelector('.modal__actions a');
        if (close) close.focus();
    });
})();
